import React from "react"

import AggregateShellComponent from "../../../../../gd-modules/common/aggregate/aggregate-shell"
import {
    AggregateFunctionType
} from "../../../../../data-structures/aggregators/types"
import TasksView_Column from "../../../../../model2/column/column"
import FieldRating from "../../rating";
import FieldRating_EditableStateful from "../editable/rating-component"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldRating_AggregateCell"
const debug = false

export default function FieldRating_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value)
    const value = isValid ? props.value : null
    const options = props.column.field?.getAggregateOptions()

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {value}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <FieldRating_EditableStateful
                    field       = {props.column.field as FieldRating}
                    value       = {value}
                    disabled    = {true}
                />}
        </AggregateShellComponent>
    )
}
